export const routes = [
  {
    path: '/sala-principal/:id/cargos-funcoes',
    component: () => import(/* webpackChunkName: "ur" */ './components/List'),
    name: 'cargo.funcao.list',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/sala-principal/novo/:id',
    component: () => import(/* webpackChunkName: "user" */ './components/Insert'),
    name: 'cargo-funcao.insert',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/sala-principal/editar/:id',
    component: () => import(/* webpackChunkName: "user" */ './components/Get'),
    name: 'cargo-funcao.edit',
    meta: {
      requiresAuth: true
    }
  }

]
